import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoIcon, SuccessIcon } from '../icons';
import { DeleteIcon } from '../icons/delete-icon';
export var Toast = function (_a) {
    var message = _a.message, description = _a.description, status = _a.status, toastId = _a.id, removeToast = _a.removeToast;
    var toastStyles = {
        success: 'bg-vjwSuccess text-white',
        error: 'bg-vjwDanger text-white',
        info: 'bg-vjwPrimary text-white',
    };
    var icons = {
        success: _jsx(SuccessIcon, {}),
        error: _jsx(DeleteIcon, {}),
        info: _jsx(InfoIcon, { className: 'size-5' }),
    };
    return (_jsx("div", { className: "".concat(toastStyles[status], " mb-2 flex w-64 justify-between gap-2 items-start rounded p-2 text-sm font-semibold"), children: _jsxs("div", { className: 'flex gap-2 items-center', children: [!!icons[status] && icons[status], _jsxs("div", { className: 'flex-1 font-normal', children: [_jsx("div", { className: 'font-semibold text-sm', children: message }), description && _jsx("div", { className: 'text-xs font-normal', children: description })] })] }) }));
};
